const AppConstants = {
  // api: process.env.REACT_APP_DENSO_QA_SERVICE_LOCAL,
  // api: process.env.REACT_APP_DENSO_QA_SERVICE,
  api: process.env.REACT_APP_DENSO_QA_DEMO,
  // api: "http://localhost:5001"
};

export default AppConstants;
